import { IUser } from '@epicuro-next/data/users';

import { AnalyticsEntity } from '../interfaces';

export function entityToListViewers(entity: AnalyticsEntity): IUser[] {
  const { topListViewers } = entity;
  if (!topListViewers) return [];

  return Object.entries(topListViewers).map(([, value]) => value);
}
